import React from 'react';
import { Icon, Modal, Divider } from 'antd';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import ClosePopUpCheckboxUI from './ClosePopUpCheckboxUI';
import getCookie from '../cookie/getCookie';


const createPkgGuide = {
    modalBtn : {
        id : 'PackageInfo.guide.modal.btn',
        text : 'Thumbnail Production Guide'
    },
    guide : {
        title : {
            id : 'PackageInfo.guide.modal.title',
            text : 'Thumbnail Production Guide'
        },
        img: require('../img/guide/thumbnail_guide_kiki.png').default,
        explain : {
            id : 'PackageInfo.guide.modal.explain',
            text : '1. An image file must be 250 x 250 (px) and below 500KB.<br/>2. Image must have a transparent background and resolution of 72dpi.<br/>3. There must be a clear margin of 20 px on all sides.<br/><p style="margin: 10px 0px">For more guide lines and limitations, visit <u><a style="color:#a202ff" href="/guide/howToUse" target="_blank">Production Guide page</a></u>.</p>'
        }
    }
};
const createStickerGuide = {
    title : {
        id : 'StickerUpload.guide.title',
        text : 'Drag and drop or click to upload your image file. You may upload multiple files at once.'
    },
    modalBtn : {
        id : 'StickerUpload.guide.modal.btn',
        text : 'Production Guide'
    },
    explain : {
        id : 'StickerUpload.guide.explain',
        text : '<span style="color:#ff6060">*</span> Make the image file exactly 618x618(px) in dimension and under 500KB in size.<br/>It must have a transparent background and a resolution of 72 dpi.<br/>There should be a clear margin of 20 px on all sides. Please refer to the <u><a style="color:#a202ff" href="/guide/howToUse" target="_blank">production guide page</a></u> for further detail.'
    },
    guide : {
        title : {
            id : 'StickerUpload.guide.modal.title',
            text : 'Sticker Production Guide'
        },
        img: require('../img/guide/sticker_upload_guide_kiki.png').default,
        explain : {
            id : 'StickerUpload.guide.modal.explain',
            text : '1. File must be 618x618px and below 500KB.<br/>2. Image must have a transparent background and resolution of 72dpi.<br/>3. There must be a clear margin of 20px on all sides.<br/><p style="margin: 10px 0px">For more guide lines and limitations, visit <u><a style="color:#a202ff" href="/guide/howToUse" target="_blank">Production Guide page</a></u>.</p>'
        }
    }
}

const selectTagGuide = {
    title : {
        id : 'SelectTag.guide.title',
        text : 'Click a sticker to select its corresponding emotion tag and language.'
    },
    modalBtn : {
        id : 'SelectTag.guide.modal.btn',
        text : 'Tag Guide'
    },
    explain : {
        id : 'SelectTag.guide.explain',
        text : 'Stickers that have been tagged are highlighted in green, while stickers that have not been tagged are highlighted in red. <br/>Please complete tagging for all stickers to submit the package.'
    },
    guide : {
        title : {
            id : 'SelectTag.guide.modal.title',
            text : 'Sticker Tag Guide'
        },
        explain : {
            title: {
                id : 'SelectTag.guide.modal.explain.title',
                text : '🔍 Tag Selection'
            },
            right: {
                id: 'SelectTag.guide.modal.explain.right',
                text : '<ul><li>An emotion or situation that can be inferred from the sticker</li><li>The first tag that comes to mind when looking at the sticker</li><li>A tag that intuitively matches<br/>the sticker</li></ul>'
            },
            wrong:{
                id: 'SelectTag.guide.modal.explain.wrong',
                text : '<ul><li>An emotion or situation that can not <br/>be inferred from the sticker</li><li>An element that has nothing to do with<br/>the sticker’s emotion or situation</li></ul>'
            }

        },
        caution : {
            title: {
                id : 'SelectTag.guide.modal.caution.title',
                text : '⚠️ Things to note when selecting tags'
            },
            description: {
                id : 'SelectTag.guide.modal.caution.description',
                text: '<ul style="list-style-type:decimal; padding-left:15px;"><li>Each sticker can have <strong>a minimum of 1 tag and a maximum of 3 tags</strong> selected.</li><li>If <strong>tags do not match the emotion or situation presented,</strong> the sticker <strong>may be rejected.</strong></li><li>Stickers without tags selected cannot be submitted.</li></ul>'
            },
            link : {
                id : 'SelectTag.guide.link.message',
                text : 'For more information about how to select tags, visit <a href="/guide/selectTags" target="_blank">How to Select Tags page</a>.'
            }
        },
        example : {
            title: {
                id : 'SelectTag.guide.modal.exmaple.title',
                text : '🏷 Tag selection examples'
            },
            explain : [
                {
                    id: 'SelectTag.guide.modal.exmaple.1',
                    text : '<div>An emotion or situation that can be inferred from the sticker</div><div>A background element that is related to the emotion or situation of the sticker</div>'
                },
                {
                    id: 'SelectTag.guide.modal.exmaple.2',
                    text : '<div>An emotion or situation that can be inferred from the sticker</div><div style="margin-top:23px; color:#ff6060;">An emotion or situation that can not be inferred from the sticker</div>'
                },
                {
                    id: 'SelectTag.guide.modal.exmaple.3',
                    text : '<div>An emotion or situation that can be inferred from the sticker</div><div style="color:#ff6060;">An emotion or situation that can not be inferred from the sticker</div>'
                },
                {
                    id: 'SelectTag.guide.modal.exmaple.4',
                    text : '<div>A tag that intuitively matches the sticker</div><div style="margin-top:5px; color:#ff6060;">An element that has nothing to do with the sticker’s emotion or situation and included in the sticker as a background</div>'
                }
            ]
        }
    }
}

class ProgressGuideView extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            visible :  getCookie(props.step) ? false : true,
        };
    }

    render(){
        const { step, language, packType } = this.props;

        const data = step === 'select-tag' ? selectTagGuide : step === 'sticker-upload' ? createStickerGuide : createPkgGuide;

        let width = 520;
        
        if(step === 'select-tag'){
            width = 1040
        }else if(step === 'package-info'){
            width = language === 'ko' ? 480 : 520;
        }else {
            width = language === 'ko' ? 440 : 520;
        }

        return(
            <div style={step === 'package-info' ? {marginLeft: '4px'} : {lineHeight: 1.5, letterSpacing: -0.42, margin: '0px 25px'}}>
                {/* modal ㅇㅏ니ㅁ */}
                {
                    step === 'package-info' ? 
                        <div style={{color:'#a202ff', textAlign: 'right', whiteSpace : 'nowrap', cursor: 'pointer'}} onClick={() => this.setState({visible : true})}>
                            <Icon type="question-circle" style={{width : 15, marginRight:6 }}/>
                        </div>
                        :
                        <div>
                            <div style={{fontSize: '16px', color : '#000', lineHeight: '24px'}}>
                                <FormattedMessage
                                    id={data.title.id}
                                    defaultMessage={data.title.text}
                                />
                                {
                                    packType &&
                                    <FormattedMessage
                                        id={`StickerUpload.guide.title.${packType}`}
                                        defaultMessage=' '
                                    />
                                }
                            </div>
                            <div style={{fontSize: '14px', color : 'rgba(0, 0, 0, 0.38)', lineHeight: '22px', letterSpacing: '-0.5px', marginTop: 1}}>
                                <FormattedHTMLMessage
                                    id={data.explain.id}
                                    defaultMessage={data.explain.text}
                                />
                            </div>
                            <div style={{marginTop: 10, color:'#a202ff', fontSize: '16px', lineHeight: '18px', letterSpacing:'-0.5px', whiteSpace : 'nowrap', cursor: 'pointer'}} onClick={() => this.setState({visible : true})}>
                                <Icon type="question-circle" style={{width : 15, marginRight:6 }}/>
                                <FormattedMessage
                                    id={data.modalBtn.id}
                                    defaultMessage={data.modalBtn.text}
                                />
                            </div>
                        </div>
                        
                }
                <Modal
                    className='progress-guide-modal'
                    title={
                        <p style={{ fontSize: 24, lineHeight: 1.67, letterSpacing: -0.62, color: '#000000', margin: '16px 0px 0px 16px'}}>
                            <FormattedMessage
                                id={data.guide.title.id}
                                defaultMessage={data.guide.title.text}
                            />
                        </p>
                    }
                    visible={this.state.visible}
                    onOk={() => this.setState({visible: false})}
                    onCancel={() => this.setState({visible: false})}
                    footer={null}
                    width={width}
                    bodyStyle={{margin: '0px 40px 33px 40px', lineHeight: 1.79, letterSpacing: -0.36, color: '#000', fontSize: 14, fontFamily: 'NotoSans'}}
                >
                    {
                        step === 'select-tag' ? 
                            <div style={{display:'flex', justifyContent:'space-between'}}>
                                <div>
                                    <div className="sticker-tag-guide-subtitle">
                                        <FormattedMessage
                                            id={data.guide.explain.title.id}
                                            defaultMessage={data.guide.explain.title.text}
                                        />
                                    </div>
                                    <div style={{display:'flex', justifyContent:'space-between', marginBottom: 50}}>
                                    {
                                        ['right', 'wrong'].map(value => 
                                            <div className="tag-selection-guide-explain-wapper" key={value} style={{marginRight: value === 'right'? 9 : 'auto'}}>
                                                <img src={require(`../img/upload/guide_modal/icon_${value}.svg`).default} alt="icon"/>
                                                <Divider style={{margin:'0px auto 5px auto'}}/>
                                                <FormattedHTMLMessage
                                                    id={data.guide.explain[value].id}
                                                    defaultMessage={data.guide.explain[value].text}
                                                />
                                            </div>
                                        )
                                    }
                                    </div>
                                    <div className="sticker-tag-guide-subtitle">
                                        <FormattedMessage
                                            id={data.guide.caution.title.id}
                                            defaultMessage={data.guide.caution.title.text}
                                        />
                                    </div>
                                    <div className="select-tag-caution">
                                        <FormattedHTMLMessage
                                            id={data.guide.caution.description.id}
                                            defaultMessage={data.guide.caution.description.text}
                                        />
                                        <FormattedHTMLMessage
                                            id={data.guide.caution.link.id}
                                            defaultMessage={data.guide.caution.link.text}
                                        />
                                    </div>
                                </div>

                                <Divider type="vertical" className="vertical-line" style={{height:424}}/>
                                <div>
                                    <div className="sticker-tag-guide-subtitle">
                                        <FormattedMessage
                                            id={data.guide.example.title.id}
                                            defaultMessage={data.guide.example.title.text}
                                        />
                                    </div>
                                    {
                                        [1,2,3,4].map(value => 
                                            <div className="sticker-tag-guide-example" key={value}>
                                                <img src={require(`../img/upload/guide_modal/example_${value}@2x.png`).default} style={{width: 221, height: 87, marginRight:5}} alt="example"/>
                                                <div className="sticker-tag-guide-example-text">
                                                    <FormattedHTMLMessage
                                                        id={data.guide.example.explain[value-1].id}
                                                        defaultMessage={data.guide.example.explain[value-1].text}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    }
                                </div>
                            </div>
                            :
                            <div>
                                <div style={{display:'flex', justifyContent:'center'}}>
                                    <img src ={data.guide.img} width="316" alt="guide"/>
                                </div>
                                <div style ={{margin : '25px 0px 20px 0px'}}>
                                    <FormattedHTMLMessage
                                        id={data.guide.explain.id}
                                        defaultMessage={data.guide.explain.text}
                                    />
                                </div> 
                            </div>
                    } 
                    {/* 다시 보지 않기 기능 추가 - local storage에 저장 */}
                    <ClosePopUpCheckboxUI 
                        isExistedCookie={getCookie(step) ? true : false}
                        cookieName={step} 
                        cookieValue={step}
                        expiredays={new Date('9999-12-31')}
                        closeFunc={()=> this.setState({visible: false})}
                    />
                </Modal>
                
            </div>
            
        );
    }


}

export default ProgressGuideView
